/**
 * 通用开关组件
 * Created by LiuHe on 2017/5/25.
 */

import React from 'react';

import RootContext from '_common/container/RootContext';

import { FormErrorType, FormType } from './FormType';
import ItemCard from './formItem/ItemCard';
import ItemCheck from './formItem/ItemCheck';
import ItemDate from './formItem/ItemDate';
import ItemMultiInput from './formItem/ItemMultiInput';
import ItemRadio from './formItem/ItemRadio';
import ItemRaw from './formItem/ItemRaw';
import ItemSearch from './formItem/ItemSearch';
import ItemSelect from './formItem/ItemSelect';
import ItemSelectDefine from './formItem/ItemSelectDefine';
import ItemText from './formItem/ItemText';
import ItemTextArea from './formItem/ItemTextArea';
import ItemUpload from './formItem/ItemUpload';

// 样式文件再全局引用 因为其他不适用该组件的样式也一致
// import '../../less/formLine.less';

class FormLine extends RootContext {
  render() {
    const { dataSource, notGuardian } = this.props;
    let { isOptional } = this.props;
    if (isOptional == null) {
      isOptional = false;
    }
    let FormItem = null;
    const { hidden } = dataSource;
    if (hidden) {
      return null;
    }
    switch (dataSource.formType) {
      case FormType.MONEY:
      case FormType.PASSWORD:
      case FormType.NUMBER:
      case FormType.TEXT:
        FormItem = <ItemText dataSource={dataSource} isOptional={isOptional} />;
        break;
      case FormType.TEXT_AREA:
        FormItem = <ItemTextArea dataSource={dataSource} />;
        break;
      case FormType.RADIO:
        FormItem = <ItemRadio dataSource={dataSource} />;
        break;
      case FormType.SELECT:
        FormItem = <ItemSelect dataSource={dataSource} />;
        break;
      case FormType.CHECK:
        FormItem = <ItemCheck dataSource={dataSource} />;
        break;
      case FormType.DATE:
        FormItem = (
          <ItemDate dataSource={dataSource} notGuardian={notGuardian} />
        );
        break;
      case FormType.MULTI_INPUT:
        FormItem = <ItemMultiInput dataSource={dataSource} />;
        break;
      case FormType.UPLOAD:
        FormItem = <ItemUpload dataSource={dataSource} />;
        break;
      case FormType.SEARCH:
        FormItem = <ItemSearch dataSource={dataSource} />;
        break;
      case FormType.SELECT_DEFINE:
        FormItem = <ItemSelectDefine dataSource={dataSource} />;
        break;
      case FormType.OTHER:
        FormItem = <ItemSearch dataSource={dataSource} />;
        break;
      case FormType.CARD:
        FormItem = <ItemCard dataSource={dataSource} />;
        break;
      case FormType.SAVE_DATA:
      case FormType.RAW:
        FormItem = <ItemRaw dataSource={dataSource} isOptional={isOptional} />;
        break;
      default:
        break;
    }
    return FormItem;
  }
}

FormLine.defaultProps = {
  dataSource: {
    key: '',
    title: '',
    extend: null,
    subtitle: null,
    placeholderLeft: null,
    placeholderRight: null,
    formType: FormType.TEXT,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};

export { FormLine, FormErrorType, FormType };
